"use client"
import "./CountryTabs.css"

const CountryTabs = ({ activeTab, country, isHeaderScrolled, isFixed }) => {
  const tabs = [
    { id: "fast-facts", label: "FAST FACTS" },
    { id: "top-universities", label: "TOP UNIVERSITIES" },
    { id: "admissions", label: "ADMISSIONS" },
    { id: "scholarships", label: "SCHOLARSHIPS" },
    { id: "visa", label: "VISA" },
    { id: "cost-of-living", label: "COST OF LIVING" },
    { id: "work-opportunities", label: "WORK OPPORTUNITIES" },
    { id: "faqs", label: "FAQS" },
  ]

  const scrollToSection = (id) => {
    const element = document.getElementById(id)
    if (element) {
      const offset = isHeaderScrolled ? 135 : 155 // Refined offset
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      })
    }
  }

  return (
    <div
      className={`country-tabs ${isHeaderScrolled ? "scrolled" : ""} ${isFixed ? "fixed" : ""}`}
      style={{
        position: isFixed ? "fixed" : "sticky",
        top: isFixed ? (isHeaderScrolled ? "70px" : "90px") : "70px",
        zIndex: 10001
      }}
    >
      <div className="tabs-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.label ? "active" : ""}`}
            onClick={() => scrollToSection(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default CountryTabs
